module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }